import React, { Fragment, useEffect } from 'react';
import CCEvents, {
  EventNames,
  EventPropertyKeys,
} from '@companycam/companycam-events';
import Helmet from 'react-helmet';
import styled from 'styled-components';
import { hideMainNavigation, showMainNavigation } from 'helpers/navigation';
import isMobile from 'helpers/isMobile';
import LoadingSpinner from './LoadingSpinner';
import TradeInfo from './TradeInfo';

const kmpxScript = `
!function(k,m,t,x,i,o){if(!k[i]){var e=k[i]=function(){e.process?e.process.apply(e,arguments):e.queue.push(arguments)};e.queue=[],e.t=1*new Date;var s=m.createElement(t);s.async=!0,s.src=x;var n=m.getElementsByTagName(t)[0];n.parentNode.insertBefore(s,n)}}(window,document,"script","https://s.kmtx.io/kmpx.js","kmpx");
kmpx('init','344', {'sid':'0edde9a5-5009-4943-8c0d-3e1cf40ba701'});
kmpx('event', 'lead');
`;

const Section = styled.div`
  display: flex;
  margin: 0 auto;
`;

const SignUpSuccess = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const choosePlans = queryParams.get('choosePlans');

  useEffect(() => {
    hideMainNavigation();
    return () => showMainNavigation();
  }, []);

  useEffect(() => {
    CCEvents.logEvent(EventNames.COMPLETE_REGISTRATION, {
      [EventPropertyKeys.REGISTRATION_METHOD]: '',
      [EventPropertyKeys.EVENT_ID]: gon.current_company_json.id,
    });
  }, []);

  return (
    <Fragment>
      <Helmet>
        <script>{kmpxScript}</script>
      </Helmet>
      {isMobile ? (
        <TradeInfo mobileDeeplinkHref="/signup/onboard" />
      ) : (
        <div className="full-screen-wrap">
          <Section>
            <LoadingSpinner
              redirect={choosePlans ? `/billing/choose_plans` : '/projects'}
            />
          </Section>
        </div>
      )}
    </Fragment>
  );
};

export default SignUpSuccess;
